import { useLvgLiveOrdersAmount } from 'hooks/games/lvg/useYourBidsOrders'
import { YourBidsTabCSS } from './YourBidsTabCSS.styled'

export const YourBidsTab = () => {
  const { liveOrdersCount } = useLvgLiveOrdersAmount()
  return (
    <YourBidsTabCSS>
      <label className='tab' id='two-tab' htmlFor='stats_tabs_two'>
        YOUR BIDS <span className='profit'>{liveOrdersCount.winningOrders || 0}</span>
        <span className='loss'>{liveOrdersCount.lossingOrders || 0}</span>
      </label>
    </YourBidsTabCSS>
  )
}
